import { Suspense, useEffect, useState } from 'react';
import { suppressNextPageTransition } from 'components/pageTransitionControl';
import { LazyLogoutModal } from 'modules/modals';
import { AccountSheet } from 'modules/profile';
import { useGoBack } from 'utils/navigation';

export const AccountPage = () => {
  const goBack = useGoBack();
  // Start closed and open on mount so the sheet slides up from the bottom (a sheet that
  // mounts already-open would just appear). On close, let the slide-down play, then pop
  // the /account route from the sheet's onExited (no animation-coupled setTimeout).
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(true), []);

  const handleClose = () => {
    setOpen(false);
    // The sheet slides down; suppress the underlying page's horizontal back-slide so the
    // only motion is top→bottom.
    suppressNextPageTransition();
  };

  return (
    <>
      <AccountSheet open={open} onClose={handleClose} onExited={goBack} />
      <Suspense>
        <LazyLogoutModal />
      </Suspense>
    </>
  );
};
